import PageTitle from "../../../components/partials/PageTitle";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { useState, useEffect } from "react";
import Form from "../../../components/form/Form";
import { useSelector } from "react-redux";
import useInputChange from "./../../../utils/hooks/useInputChange";
import { isEmptyObject } from "./../../../utils/validators/validators";
import {
  addStaffNextOfKinInfo,
  resetStaffRecords,
  resetStaffStatus,
} from "./../../../redux/slice/staff/staffSlice";
import { useDispatch } from "react-redux/es/exports";
import PhoneInput from "react-phone-number-input";

const AddContactInformation = () => {
  const [error, setError] = useState({});
  // get staff records from state
  const { app_id, staff_records, pages, isSuccess, isLoading, isError } =
    useSelector((state) => state.staff);
  const { user_permissions } = useSelector((state) => state.auth?.user);

  // initialize form fields
  const [staffInputData, setStaffInputData] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    contact_address: "",
    relationship: "",
    app_id: app_id,
  });

  // handle input change
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );
  const [phoneNumber, setPhoneNumber] = useState("");
  const [borderColor, setBorderColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (phone_no) => {
    if (!phone_no) {
      setBorderColor("red");
      setErrorMessage("Please enter phone number");
    } else {
      setBorderColor("");
      setErrorMessage("");

      setPhoneNumber(phone_no);
    }
    setStaffInputData(staffInputData);
  };

  const { nextPage } = useOutletContext();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // submit form
  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      if (!phoneNumber) {
        setBorderColor("#fa5c7c");
        setErrorMessage("Please enter phone number");
        return;
      }
      dispatch(
        addStaffNextOfKinInfo({ ...staffInputData, phone_number: phoneNumber })
      );
    }
  };

  const breadcrumb = {
    from: {
      title: "Add Staff",
      link: "/admin/add-staff",
    },
    current: {
      title: "Next of kin information",
      link: null,
    },
  };

  useEffect(() => {
    !app_id
      ? navigate(-1)
      : nextPage &&
        navigate(nextPage, { state: { from: location }, replace: true });
  }, [pages]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetStaffRecords());
      navigate("/admin/list-of-staffs", {
        state: { from: location },
        replace: true,
      });
    }
    return () => {
      dispatch(resetStaffStatus());
    };
  }, [staff_records, isError, isSuccess, isLoading]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "staff module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create staff"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Staff Creation' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary'>
                    Next of Kin Information
                  </h4>
                </div>
              </div>
              <Form
                setError={(e) => {
                  if (!phoneNumber) {
                    setBorderColor("#fa5c7c");
                    setErrorMessage("Please enter phone number ");
                  }
                  setError(e);
                }}
                submitHandler={handleSubmit}
                values={staffInputData}
              >
                <div className='row'>
                  <div className='mb-0 col-md-4'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      First Name <span className='text-danger'>*</span>{" "}
                    </label>
                    <input
                      min_length='2'
                      textname='first name'
                      name='first_name'
                      onChange={handleChange}
                      value={input.first_name}
                      type='text'
                      className={`form-control ${
                        error.first_name && "is-invalid"
                      }`}
                      id='inputEmail4'
                      placeholder='Enter First Name'
                    />
                    {error.first_name && (
                      <span className='invalid-feedback'>
                        {error.first_name}
                      </span>
                    )}
                  </div>

                  <div className='mb-0 col-md-4'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Middle Name
                    </label>
                    <input
                      min_length={input.middle_name && "3"}
                      validate={!input.middle_name ? "false" : undefined}
                      textname='middle name'
                      name='middle_name'
                      onChange={handleChange}
                      value={input.middle_name}
                      type='text'
                      className={`form-control ${
                        error.middle_name && "is-invalid"
                      }`}
                      id='inputEmail4'
                      placeholder='Enter Middle Name'
                    />
                    {error.middle_name && (
                      <span className='invalid-feedback'>
                        {error.middle_name}
                      </span>
                    )}
                  </div>

                  <div className='mb-0 col-md-4'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Last Name <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length='3'
                      textname='last name'
                      name='last_name'
                      onChange={handleChange}
                      value={input.last_name}
                      type='text'
                      className={`form-control ${
                        error.last_name && "is-invalid"
                      }`}
                      id='inputEmail4'
                      placeholder='Enter Last Name'
                    />
                    {error.last_name && (
                      <span className='invalid-feedback'>
                        {error.last_name}
                      </span>
                    )}
                  </div>
                </div>
                <div className='row mt-3'>
                  <div className='mb-0 col-md-6'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Phone Number
                      <span className='text-danger'>*</span>
                    </label>

                    <PhoneInput
                      placeholder='Enter phone number'
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setBorderColor("red");
                          setErrorMessage("Please enter phone number");
                        } else {
                          setBorderColor("");
                          setErrorMessage("");
                        }
                      }}
                      defaultCountry='NG'
                      className='form-control custom-phone-input'
                      style={{ borderColor: `${borderColor}` }}
                    />
                    {errorMessage && (
                      <span
                        className='text-danger'
                        style={{ fontSize: "12px" }}
                      >
                        {errorMessage}
                      </span>
                    )}
                    {/* </div> */}
                  </div>
                  <div className='mb-0 col-md-6'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Email Address
                    </label>
                    <input
                      validate='false'
                      textname='email address'
                      name='email'
                      onChange={handleChange}
                      value={input.email}
                      type='email'
                      className={`form-control ${error.email && "is-invalid"}`}
                      id='inputEmail4'
                      placeholder='Email'
                    />
                    {error.email && (
                      <span className='invalid-feedback'>{error.email}</span>
                    )}
                  </div>
                </div>
                <div className='row mt-3'></div>
                <div className='row g-2'>
                  <div className='mb-3 mt-3'>
                    <label htmlFor='contact_address' className='form-label'>
                      Contact Address <span className='text-danger'>*</span>
                    </label>
                    <textarea
                      min_length='5'
                      max_length='255'
                      textname='contact address'
                      name='contact_address'
                      value={input.contact_address}
                      onChange={handleChange}
                      id='contact_address'
                      className={`form-control ${
                        error.contact_address && "is-invalid"
                      }`}
                      rows='6'
                      placeholder='Enter address here'
                    ></textarea>
                    {error.contact_address && (
                      <span className='invalid-feedback'>
                        {error.contact_address}
                      </span>
                    )}
                  </div>
                </div>
                <div className='row g-2'>
                  <div className='mb-3'>
                    <label htmlFor='relationship' className='form-label'>
                      Relationship with staff{" "}
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      textname='relationship'
                      name='relationship'
                      value={input.relationship}
                      onChange={handleChange}
                      id='relationship'
                      className={`form-control ${
                        error.relationship && "is-invalid"
                      }`}
                      placeholder='Enter relationship here'
                    />
                    {error.relationship && (
                      <span className='invalid-feedback'>
                        {error.relationship}
                      </span>
                    )}
                  </div>
                </div>

                <div className='float-end'>
                  <button
                    disabled={isLoading && true}
                    className='btn btn-primary w-10'
                  >
                    Submit
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      {/* end content */}
    </>
  );
};

export default AddContactInformation;
